import NotificationsIcon from "@material-ui/icons/Notifications";
import HeadsetMicIcon from "@material-ui/icons/HeadsetMic";
import PersonIcon from "@material-ui/icons/Person";
import {
  PRODUCTS,
  ORDERS,
  ROLES,
  NOTIFICATIONS,
  SUPPORT,
  BRANDS,
  USERS,
  NFT_COLLECTIONS,
  NFT_DROPS,
  NFT_PERKS,
  ADD_NFT_COLLECTION,
  ADD_NFT_DROP,
  ADD_NFT_PERK,
  EDIT_NFT_COLLECTION,
  EDIT_NFT_DROP,
  EDIT_NFT_PERK,
  GAMES,
  ADD_GAME,
  EDIT_GAME,
  CATEGORIES,
  STATES,
  QR_SEQUENCES,
  ADMINS,
  EMPLOYEES,
  SETTINGS_BUNDLES_SURFACES,
} from "./constants";
import brands from "./assets/img/brands.svg";
import products from "./assets/img/products.svg";
import nft from "./assets/img/nft.svg";
import collections from "./assets/img/collections.svg";
import drops from "./assets/img/drops.svg";
import perks from "./assets/img/perks.svg";
import orders from "./assets/img/orders.svg";
import usa from "./assets/img/usa.svg";
import qrScannerSvg from "./assets/img/qr-scanner-white.svg";
import games from "./assets/img/games.svg";
import category from "./assets/img/category.svg";

export const ROUTES = [
  {
    name: "Brands",
    path: BRANDS,
    icon: <img src={brands} alt="brands" />,
    access: [ROLES.admin, ROLES.superAdmin],
  },
  {
    name: "Admins",
    path: ADMINS,
    icon: <PersonIcon />,
    access: [ROLES.superAdmin],
  },
  {
    name: "Products",
    path: PRODUCTS,
    icon: <img src={products} alt="products" />,
    access: [ROLES.superAdmin, ROLES.admin],
  },
  {
    name: "Categories",
    path: CATEGORIES,
    icon: <img src={category} alt="categories" />,
    access: [ROLES.admin, ROLES.superAdmin],
  },
  {
    name: "NFTs",
    path: "#",
    icon: <img src={nft} alt="nft" />,
    access: [ROLES.admin, ROLES.superAdmin],
    children: [
      {
        name: "Collections",
        path: NFT_COLLECTIONS,
        icon: <img src={collections} alt="nft" />,
        access: [ROLES.admin, ROLES.superAdmin],
      },
      {
        name: "Drops",
        path: NFT_DROPS,
        icon: <img src={drops} alt="drops" />,
        access: [ROLES.admin, ROLES.superAdmin],
      },
      {
        name: "Perks",
        path: NFT_PERKS,
        icon: <img src={perks} alt="perks" />,
        access: [ROLES.admin, ROLES.superAdmin],
      },
    ],
    selected: [
      ADD_NFT_COLLECTION,
      EDIT_NFT_COLLECTION,
      ADD_NFT_DROP,
      EDIT_NFT_DROP,
      ADD_NFT_PERK,
      EDIT_NFT_PERK,
    ],
  },
  // {
  //   name: "StashBox",
  //   path: "#",
  //   icon: <img src={stashBox} alt="stashBox" />,
  //   access: [ROLES.admin, ROLES.superAdmin],
  //   children: [
  //     {
  //       name: "Overview",
  //       path: STASHBOX,
  //       icon: <img src={stashBox} alt="stashBox" />,
  //       access: [ROLES.admin, ROLES.superAdmin],
  //       external: true,
  //     },
  //     {
  //       name: "Point",
  //       path: PRODUCT_POINT,
  //       icon: <img src={productsPoint} alt="productsPoint" />,
  //       access: [ROLES.admin, ROLES.superAdmin],
  //       external: true,
  //     },
  //   ],
  // },
  {
    name: "Games",
    path: GAMES,
    icon: <img src={games} alt="games" />,
    access: [ROLES.admin, ROLES.superAdmin],
    selected: [GAMES, ADD_GAME, EDIT_GAME],
  },
  {
    name: "Users",
    path: USERS,
    icon: <PersonIcon />,
    access: [ROLES.admin, ROLES.superAdmin],
    selected: ["/orders/user/:id"],
  },
  {
    name: "Orders",
    path: ORDERS,
    icon: <img src={orders} alt="orders" />,
    access: [ROLES.admin, ROLES.superAdmin],
  },
  {
    name: "Employees",
    path: EMPLOYEES,
    icon: <PersonIcon />,
    access: [ROLES.superAdmin],
  },
  {
    name: "Notifications",
    path: NOTIFICATIONS,
    icon: <NotificationsIcon />,
    access: [ROLES.admin, ROLES.superAdmin],
  },
  {
    name: "Support",
    path: SUPPORT,
    icon: <HeadsetMicIcon />,
    access: [ROLES.admin, ROLES.superAdmin],
  },
  {
    name: "States",
    path: STATES,
    icon: <img src={usa} alt="usa" width={24} height={24} />,
    access: [ROLES.admin, ROLES.superAdmin],
  },
  {
    name: "Surfaces",
    path: SETTINGS_BUNDLES_SURFACES,
    icon: <img src={category} alt="surfaces" />,
    access: [ROLES.superAdmin],
  },
  {
    name: "QR Sequences",
    path: QR_SEQUENCES,
    icon: <img src={qrScannerSvg} alt="QR Sequences" width={24} height={24} />,
    access: [ROLES.superAdmin],
  },
];
